import {
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from '@angular/core';
import { ButtonConfig } from '@zipari/shared-ds-util-button';
import { AuthLoginColumnConfig } from './auth.model';
import { DSAuthService } from './auth.service';
import { AUTH_URLS } from './constants/auth-urls.constant';

@Component({
  selector: 'ds-auth',
  styleUrls: ['./auth.component.scss'],
  templateUrl: './auth.component.html',
})
export class DSAuthComponent implements OnInit, OnDestroy {
  @Input() configuration;
  @Output() submitForgotPassword: EventEmitter<any> = new EventEmitter();
  @Output() submitForgotUsername: EventEmitter<any> = new EventEmitter();
  @Output() submitLogin: EventEmitter<any> = new EventEmitter();
  @Output() submitRegistration: EventEmitter<any> = new EventEmitter();

  constructor(public authService: DSAuthService) {}

  ngOnInit() {
    this.authService.configuration = this.configuration;
    this.authService.authUrls = this.configuration.authUrls || {
      forgotPassword: AUTH_URLS.FORGOT_PASSWORD,
      forgotUsername: AUTH_URLS.FORGOT_USERNAME,
      login: AUTH_URLS.LOGIN,
      okta: AUTH_URLS.OKTA,
      registration: AUTH_URLS.REGISTRATION,
    };

    this.authService.forgotPasswordFormValue$.subscribe((value) => {
      this.submitForgotPassword.emit(value);
    });
    this.authService.forgotUsernameFormValue$.subscribe((value) => {
      this.submitForgotUsername.emit(value);
    });
    this.authService.loginFormValue$.subscribe((value) => {
      this.submitLogin.emit(value);
    });
    this.authService.registrationFormValue$.subscribe((value) => {
      this.submitRegistration.emit(value);
    });
  }

  ngOnDestroy() {
    this.authService.loginFormValue.next(null);
    this.authService.registrationFormValue.next(null);
    this.authService.forgotPasswordFormValue.next(null);
    this.authService.forgotUsernameFormValue.next(null);
  }

  /** A config object with empty strings should not be shown. */
  checkIfConfigContainsAnyValues(
    config:
      | AuthLoginColumnConfig
      | string[]
      | { label: string }[]
      | ButtonConfig,
  ) {
    return Object.keys(config).some((key) => {
      if (typeof config[key] === 'object') {
        return this.checkIfConfigContainsAnyValues(config[key]);
      } else {
        return config[key];
      }
    });
  }
}
